import * as PoolDetailActions  from '../actions/poolDetails'
import * as RestaurantActions from '../actions/poolRestaurants'

const normalizeBoolean = (value) => value === true || value === 'true' || value === 1
const normalizeThreshold = (value) => value == null ? null : Number(value)

const initialState = {
  poolName: "",
  timeZone: "",
  poolZone: "",
  partnerSubscriptionId: "",
  offlineEvents: [],
  partnerId: "",
  isLoading: true,
  logs: {
    data: [],
    totalItems: 0,
    itemsPerPage: 25
  },
  restaurants: {
    data: []
  },
  poolSummary: {
    eventCount: '',
    lastOnline: '',
    lastOffline: '',
    currentStatus: '',
    bestGuessReceived: '',
    bestGuess: '',
    offlineThreshold: null,
    onlineThreshold: null,
    isDefault: false,
    poolMode: '',
    graphData: [],
    riskLevelData: [],
    isLoading: true,
    riskLevel: 0
  },
  restaurantDisplayEditMode: false,
  poolInfoEditMode: false

}


export default (state = initialState, action) => {
  switch (action.type) {

  case PoolDetailActions.LOADPOOL_REQUESTED:
    return {
      ...state,
      id: action.id,
      isLoading: true
    }

  case PoolDetailActions.LOADPOOL:
    return {
      ...state,
      poolName: action.data.name,
      poolZone: action.data.poolZone,
      timeZone: action.data.timeZone,
      partnerSubscriptionId: action.data.partnerSubscriptionId,
      offlineEvents: action.data.offlineEvents || [],
      partnerId: action.data.partnerId,
      isLoading: true
    }

  case PoolDetailActions.LOADPOOL_ERROR:
    return {
      ...state,
      error: action.error,
      isLoading: true
    }

  case PoolDetailActions.LOAD_LOGS_REQUESTED:
    return {
      ...state,
      logs: {
        ...state.logs,
        data: [],
        totalItems: 0,
        isLoading: true
      }
    }

  case PoolDetailActions.LOAD_LOGS:
    return {
      ...state,
      logs: {
        ...state.logs,
        data: action.data.data,
        totalItems: action.data.totalItems,
        isLoading: false
      }
    }

  case PoolDetailActions.LOAD_LOGS_ERROR:
    return {
      ...state,
      logs: {
        ...state.logs,
        data: [],
        error: action.error,
        isLoading: false
      }

    }

  case RestaurantActions.LOAD_POOL_RESTAURANTS_REQUESTED:
    return {
      ...state,
      isLoading: true,
      restaurants: {
        ...state.restaurants,
        data: []
      }
    }

  case RestaurantActions.LOAD_POOL_RESTAURANTS:
    return {
      ...state,
      isLoading: false,
      restaurants: {
        ...state.restaurants,
        data: action.data
      }
    }

  case RestaurantActions.LOAD_POOL_RESTAURANTS_ERROR:
    return {
      ...state,
      isLoading: true,
      restaurants: {
        ...state.restaurants,
        data: [],
        error: action.error
      }

    }

  case RestaurantActions.POOL_RESTAURANTS_SAVED:
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        data: action.restaurants
      }
    }

  case PoolDetailActions.LOAD_POOLSUMMARY_REQUESTED:
    return {
      ...state,
      poolSummary: {
        ...state.poolSummary,
        isLoading: true
      }
    }

  case PoolDetailActions.LOAD_POOLSUMMARY:
    return {
      ...state,
      poolSummary: {
        ...state.poolSummary,
        eventCount: action.data.eventCount,
        lastOnline: action.data.lastOnline,
        lastOffline: action.data.lastOffline,
        currentStatus: action.data.currentStatus,
        offlineThreshold: normalizeThreshold(action.data.offlineThreshold),
        onlineThreshold: normalizeThreshold(action.data.onlineThreshold),
        isDefault: normalizeBoolean(action.data.isDefault),
        bestGuessReceived: action.data.bestGuessReceived,
        bestGuess: action.data.bestGuess,
        poolMode: action.data.poolMode,
        graphData: action.data.graphData,
        riskLevel: action.data.riskLevel,
        riskLevelData: action.data.riskLevelData,
        isLoading: false
      }
    }

  case PoolDetailActions.LOAD_POOLSUMMARY_ERROR:
    return {
      ...state,
      poolSummary: {
        ...state.poolSummary,
        error: action.error,
        isLoading: false
      }

    }

  default:
    return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/poolDetails.js